// @flow
import $ from 'jquery';

const disposeTooltip = $selector => () => $selector.tooltip('dispose');

const noticeNotInputFullWith = input => {
  const $selector = $(input);

  $selector.tooltip({
    trigger: 'focus',
    title: '半角で入力してください',
  });

  $selector.trigger('focus');

  $selector.blur(disposeTooltip($selector));
};

export const withoutFullwithNumberMask = (
  $scope: any,
  selector: any,
  mask: any,
  options: any,
  ...maskAgrements: any
) => {
  const $selector = $scope.find(selector);

  if (!options) options = {};

  const { onChange } = options;

  const handleOnChange = (value, event, currentField, maskOptions) => {
    const $input = $(currentField);
    if (/[０-９]/.test(value)) {
      noticeNotInputFullWith(currentField);
      $input.val(value.replace(/[０-９]/g, ''));
      $input.unmask().mask(mask, options, ...maskAgrements);
    } else if (onChange) {
      onChange(value, event, currentField, maskOptions);
      disposeTooltip($input)();
    }
  };

  options.onChange = handleOnChange;

  $selector.mask(mask, options, ...maskAgrements);

  $selector.on('change', event => {
    const $input = $(event.target);
    const value = $input.val();

    $input.val(value.replace(/[０-９]/g, ''));
    $input.unmask().mask(mask, options, ...maskAgrements);
  });
};

export default ($scope: any = $('body')) => {
  $.jMaskGlobals = {
    translation: {
      // $FlowFixMe
      0: {
        pattern: /[０-９\d]/,
      },
      '#': {
        pattern: /[０-９\d]/,
        recursive: true,
      },
    },
  };

  withoutFullwithNumberMask($scope, '.zip-code-field', '000-0000', {
    reverse: true,
  });
  withoutFullwithNumberMask($scope, '.zip-code', '000-0000', {
    reverse: true,
  });
  withoutFullwithNumberMask($scope, '.phone-number', '000-0000-0000', {
    reverse: true,
  });
  withoutFullwithNumberMask($scope, 'input.positive-number-input', '#0', {
    reverse: true,
  });
  withoutFullwithNumberMask($scope, '.corporate-number', '0000-00-0000', {
    reverse: true,
  });
  withoutFullwithNumberMask(
    $scope,
    'input.currency-input, .currency',
    '#,##0',
    { reverse: true },
  );
  withoutFullwithNumberMask($scope, 'input.date-field', '0000/00/00');
  withoutFullwithNumberMask($scope, 'input[name="year"]', '0000');
  withoutFullwithNumberMask($scope, 'input[name="month"]', '00');
  withoutFullwithNumberMask($scope, 'input[name="day"]', '00');
};
